import React from "react";
import { BsTwitter, BsGithub } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

import "./SocialMedia.scss";
const SocialMedia = () => {
  return (
    <div className="app__social">
      <a href="https://twitter.com/FuzeThien" target="_blank" rel="noreferrer">
        <div>
          <BsTwitter />
        </div>
      </a>
      <a
        href="https://www.facebook.com/fuzethien/"
        target="_blank"
        rel="noreferrer"
      >
        <div>
          <FaFacebookF />
        </div>
      </a>
      <a href="https://github.com/thien115116" target="_blank" rel="noreferrer">
        <div>
          <BsGithub />
        </div>
      </a>
    </div>
  );
};

export default SocialMedia;
